import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Hero from "../Components/Hero";
import { aboutPoints, certificates, featuredProductImages, featureProductFeatures, products, stats } from "../Data";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Cta from "../Components/Cta";
import Industries from "../Components/Industries";
import Clients from "../Components/Clients";
import OtherBlogs from "../Components/OtherBlogs";
import SchemaMarkup from "../Components/SchemaMarkup";
import organizationSchema from "../Schema/organizationSchema";
import websiteSchema from "../Schema/websiteSchema";
import WebPageSchema from "../Schema/webPageSchema";
/*import YoutubeSection from "../Components/YoutubeSection";*/

const Home=()=>{

    useEffect(() => {
    document.title =
      "Gurukrupa Wood Pvt. Ltd. | Wooden Packaging Solutions";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets, boxes, crates & export packaging solutions for industrial and logistics needs."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://gurukrupawood.com/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Gurukrupa Wood Pvt. Ltd. | Wooden Packaging Solutions"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets, boxes, crates & export packaging solutions for industrial and logistics needs."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://gurukrupawood.com/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://gurukrupawood.com//home.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Gurukrupa Wood Pvt. Ltd. | Wooden Packaging Solutions"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets, boxes, crates & export packaging solutions for industrial and logistics needs."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://gurukrupawood.com//home.webp"
    );
  }
  }, []);


     const { ref: statsRef, inView: statsInView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

const [activeIndex, setActiveIndex] = useState(0);

useEffect(() => {

  const interval = setInterval(() => {

    setActiveIndex((prev) =>
      prev === featuredProductImages.length - 1 ? 0 : prev + 1
    );

  }, 5000);

  return () => clearInterval(interval);

}, []);

  /* NEXT */

  const handleNext = () => {
  setActiveIndex((prev) =>
    prev === featuredProductImages.length - 1 ? 0 : prev + 1
  );
};

const handlePrev = () => {
  setActiveIndex((prev) =>
    prev === 0 ? featuredProductImages.length - 1 : prev - 1
  );
};

const homeSchema = WebPageSchema({
    name: "Gurukrupa Wood Pvt. Ltd.",
    url: "https://gurukrupawood.com/",
    description:
      "Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets, boxes, crates and export packaging solutions for industrial and logistics needs."
  });

    return(
        <>

      <SchemaMarkup data={organizationSchema} />
      <SchemaMarkup data={websiteSchema} />
      <SchemaMarkup data={homeSchema} />

     {/**HERO SECTION */}
     <Hero />

     {/**ABOUT US SECTION */}
     <section className="about-section container">

  {/* LEFT CONTENT */}
  <motion.div
    className="about-left"
    initial={{ opacity: 0, x: -80 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.3 }}
  >

    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1, duration: 0.5 }}
      viewport={{ once: true }}
    >
      ABOUT US
    </motion.h3>

    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.7 }}
      viewport={{ once: true }}
    >
      Quality Packaging, Delivered With Trust
    </motion.h2>

    <motion.p
      className="section-text"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.35, duration: 0.7 }}
      viewport={{ once: true }}
    >
      Established in 2013, Gurukrupa Wood Pvt. Ltd. is a leading
      manufacturer and supplier of high-quality wooden packaging products.
      With advanced infrastructure, skilled professionals, and a strong
      focus on quality, we deliver durable and customised packaging
      solutions that ensure safety, strength, and satisfaction. Driven by
      innovation and a commitment to excellence, we continuously evolve our
      processes to meet the dynamic demands of global logistics and
      industrial standards. By adhering to international phytosanitary
      regulations and ISPM-15 standards, we empower businesses to export
      their goods with total confidence, ensuring seamless transit across
      borders.
    </motion.p>

    <motion.a
      href="/about-us"
      className="green-btn"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{
        delay: 0.5,
        duration: 0.5,
      }}
      viewport={{ once: true }}
      whileHover={{
        scale: 1.05,
        y: -2,
      }}
      whileTap={{ scale: 0.97 }}
    >
      Know more about us
    </motion.a>

  </motion.div>

  {/* RIGHT CARDS */}
  <motion.div
    className="about-right"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >

    {aboutPoints.map((item, i) => (
      <motion.div
        className="about-cards"
        key={i}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
        transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -6,
        }}
      >

        <motion.img
          src={item.icon}
          alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
          whileHover={{
            rotate: 4,
            scale: 1.08,
          }}
          transition={{ duration: 0.3 }}
        />

        <div className="about-card-col">
          <h4 className="card-heading">{item.title}</h4>
          <p className="section-text">{item.desc}</p>
        </div>

      </motion.div>
    ))}

  </motion.div>

</section>

     {/**PRODUCTS GRID */}
    <section className="products-section container" id="products">

  {/* TOP */}
  <motion.div
    className="products-top"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.3 }}
  >

    <div className="products-heading">

      <motion.h3
        className="section-subheading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
        viewport={{ once: true }}
      >
        OUR PRODUCTS
      </motion.h3>

      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
        viewport={{ once: true }}
      >
        Strong. Durable. Reliable. Built for Every Industry.
      </motion.h2>

    </div>

  </motion.div>

  {/* PRODUCTS GRID */}
  <motion.div
    className="products-grid"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.16,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >

    {products.slice(0,4).map((item, i) => (
      <motion.div
        className="products-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
          },
          visible: {
            opacity: 1,
            y: 0,
          },
        }}
        transition={{
          duration: 0.75,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
        }}
      >
        <Link to={`/products/${item.slug}`}>
        {/* IMAGE ZOOM */}
        <motion.div
          style={{ overflow: "hidden" }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
            whileHover={{
              scale: 1.08,
            }}
            transition={{ duration: 0.5 }}
          />
        </motion.div>

        {/* CONTENT */}
        <motion.div
          className="product-card"
          initial={{ opacity: 0.9 }}
          whileHover={{
            opacity: 1,
          }}
        >

          <h4 className="card-heading">{item.title}</h4>

          <p className="section-text">{item.desc}</p>

         <motion.a
  href={`/products/${item.slug}`}
  className="product-card-link"
  whileHover="hover"
  initial="rest"
>

  <motion.span
    className="know-more-text"
    variants={{
      rest: {
        opacity: 0,
        width: 0,
        marginRight: 0,
      },
      hover: {
        opacity: 1,
        width: "auto",
        marginRight: 4,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    Know More
  </motion.span>

  <motion.span
    className="arrow-icon"
    variants={{
      rest: {
        x: 0,
      },
      hover: {
        x: 8,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    →
  </motion.span>

</motion.a>

        </motion.div>
</Link>
      </motion.div>
    ))}

  </motion.div>

</section>

      {/**FEATURED PRODUCT SECTION */}
      <section className="featured-product-section container">
        <h3 className="section-subheading">OUR FEATURED PRODUCT</h3>
        <h2 className="section-heading">Heavy-Duty Wooden Pallets Built for Industrial Strength</h2>
         <div className="product-intro-section">
        
                  <div className="product-intro-grid">
        
                    {/* LEFT */}
        
                    <div className="product-intro-gallery">
        
                      {/* BIG IMAGE */}
        
                      <div className="product-intro-main-image-wrapper">
        
                       <AnimatePresence mode="wait">
        
          <motion.img
            key={featuredProductImages[activeIndex]?.big}
            src={featuredProductImages[activeIndex]?.big}
           alt={
          activeIndex === 0
            ? `Heavy-Duty Wooden Pallets Built for Industrial Strength | Gurukrupa Wood Pvt. Ltd.`
            : `Heavy-Duty Wooden Pallets Built for Industrial Strength ${activeIndex} | Gurukrupa Wood Pvt. Ltd.`
        }
            className="product-intro-main-image"
        
            initial={{
              opacity: 0,
              scale: 0.96,
            }}
        
            animate={{
              opacity: 1,
              scale: 1,
            }}
        
            exit={{
              opacity: 0,
            }}
        
            transition={{
              duration: 0.4,
            }}
          />
        
        </AnimatePresence>
        
                      </div>
        
                      {/* THUMBNAILS */}
        
                      <div className="product-intro-thumb-row">
        
                        {/* LEFT ARROW */}
        
                        <button
          type="button"
          className="product-intro-arrow"
          onClick={handlePrev}
        >
                          <FaChevronLeft />
                        </button>
        
                        {/* THUMB GRID */}
        
                       <div className="product-intro-thumb-grid">
        
          {featuredProductImages.map((img, i) => {
        
            if (i === activeIndex) return null;
        
            return (
        
              <motion.div
                key={i}
                className="product-intro-thumb-card"
                whileHover={{
                  y: -4,
                }}
                onClick={() => setActiveIndex(i)}
              >
        
                <img
                  src={img.small}
                 alt={
          i === 0
            ? `Heavy-Duty Wooden Pallets Built for Industrial Strength | Gurukrupa Wood Pvt. Ltd.`
            : `Heavy-Duty Wooden Pallets Built for Industrial Strength ${i} | Gurukrupa Wood Pvt. Ltd.`
        }
                />
        
              </motion.div>
        
            );
          })}
        
        </div>
        
                        {/* RIGHT ARROW */}
        
                        <button
                          className="product-intro-arrow"
                          onClick={handleNext}
                        >
                          <FaChevronRight />
                        </button>
        
                      </div>
        
                    </div>
        
                    {/* RIGHT */}
        
                    <div className="product-intro-content">        
                      <motion.p
                        className="section-text"
                        initial={{
                          opacity: 0,
                          y: 20,
                        }}
                        whileInView={{
                          opacity: 1,
                          y: 0,
                        }}
                        transition={{
                          duration: 0.7,
                          delay: 0.1,
                        }}
                        viewport={{
                          once: true,
                        }}
                      >
                       Our wooden pallets are manufactured using high-quality timber and advanced production techniques to ensure durability, strength, and long-lasting performance. Designed for industrial storage, logistics, warehouse handling, and export applications, these pallets provide reliable support for heavy loads and safe transportation.
                      </motion.p>
        
                      {/* FEATURES */}
        
                      <div className="product-intro-features-grid">
        
                        {featureProductFeatures.map((item, i) => (
        
                          <motion.div
                            className="product-intro-feature-card"
                            key={i}
                            initial={{
                              opacity: 0,
                              y: 20,
                            }}
                            whileInView={{
                              opacity: 1,
                              y: 0,
                            }}
                            transition={{
                              duration: 0.5,
                              delay: i * 0.08,
                            }}
                            viewport={{
                              once: true,
                            }}
                          >
        
                            <div className="product-intro-feature-icon">
        
                              <img
                                src={item.icon}
                                alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
                              />
        
                            </div>
        
                            <h4 className="card-heading">
                              {item.title}
                            </h4>
        
                          </motion.div>
        
                        ))}
        
                      </div>
        
                      {/* BUTTONS */}
        
                      <div className="product-intro-btn-row">
        
                        <a
                          href="/products/customised-packaging"
                          className="green-btn"
                        >
                          Get a Quote
                        </a>
        
                        <a
                          href="/gurukrupa-brochure.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="product-intro-outline-btn"
                        >
                          Download Brochure
                        </a>
        
                      </div>
        
                    </div>
        
                  </div>
        
                </div>
      </section>

      {/**CORPORATE VIDEO SECTION */}
      {/*<YoutubeSection />*/}

     {/**WHY CHOOSE US SECTION */}
     <section className="why-choose-section" ref={statsRef}>

  <div className="container">

    {/* HEADING */}
    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      WHY CHOOSE US
    </motion.h3>

    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{ once: true }}
    >
      Strength You Can Depend On.
    </motion.h2>

    {/* STATS GRID */}
    <motion.div
      className="stats-grid"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.15,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >

      {stats.map((item, i) => (
        <motion.div
          className="stat-card"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 50,
              scale: 0.92,
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
            },
          }}
          transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            y: -8,
            scale: 1.03,
          }}
        >

          {/* NUMBER */}
          <motion.h4
            className="card-heading"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              delay: 0.2 + i * 0.1,
              duration: 0.5,
            }}
            viewport={{ once: true }}
          >
            {statsInView && (
              <CountUp
                end={item.number}
                duration={3}
              />
            )}
            {item.suffix}
          </motion.h4>

          {/* TEXT */}
          <motion.p
            className="section-text"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              delay: 0.35 + i * 0.1,
              duration: 0.5,
            }}
            viewport={{ once: true }}
          >
            {item.title}
          </motion.p>

        </motion.div>
      ))}

    </motion.div>

  </div>

</section>

     {/**INDUSTRIES SECTION */}
     <Industries />

     {/**OUR VALUABLE CLIENTS SECTION */}
     <Clients />

     {/**CERTIFICATES SECTION */}
     <section className="certificates-section container">

  {/* SUBHEADING */}
  <motion.h3
    className="section-subheading"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    CERTIFIED QUALITY & TRUST
  </motion.h3>

  {/* HEADING */}
  <motion.h2
    className="section-heading"
    initial={{ opacity: 0, y: 35 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      delay: 0.15,
      duration: 0.75,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true }}
  >
    Recognised Certifications that Reflect Our Commitment
  </motion.h2>

  {/* DESCRIPTION */}
  <motion.p
    className="section-text"
    initial={{
      opacity: 0,
      y: 35,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    transition={{
      delay: 0.3,
      duration: 0.8,
    }}
    viewport={{ once: true }}
  >
    At Gurukrupa Wood Pvt. Ltd., quality, reliability,
    and industry compliance are at the core of everything
    we manufacture. Our certifications reflect our
    commitment to maintaining high production standards,
    safe packaging practices, and trusted industrial
    operations. From internationally recognised quality
    certifications to government-authorised approvals,
    every certification strengthens the confidence our
    clients place in us for durable and dependable
    wooden packaging solutions.
  </motion.p>

  {/* GRID */}
  <motion.div
    className="certificates-grid"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.12,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.12 }}
  >

    {certificates.map((item, i) => (

      <motion.div
        className="certficates-img"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            y: 0,
            scale: 1,
          },
        }}
        transition={{
          duration: 0.75,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
          scale: 1.03,
        }}
      >

        <motion.img
          src={item.img}
          alt={`Recognised Certifications that Reflect Our Commitment ${i + 1} | Gurukrupa Wood Pvt. Ltd.`}
          initial={{
            opacity: 0,
            scale: 1.08,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            delay: 0.15 + i * 0.08,
            duration: 0.7,
          }}
          viewport={{ once: true }}
          whileHover={{
            scale: 1.04,
          }}
        />

      </motion.div>

    ))}

  </motion.div>

</section>

{/**BLOGS GRID */}
<OtherBlogs />

     {/**CTA SECTION */}
     <Cta />
        </>
    )
}
export default Home;
